import { type SbBlokData, storyblokEditable } from "@storyblok/react/rsc";
import { Slot } from "@trydig/ui";
import type { ComponentProps, PropsWithChildren } from "react";
import type { ISbComponentType } from "storyblok-js-client";

export interface BlokWrapProps extends ComponentProps<"div"> {
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	editable: ISbComponentType<any>;
	layout?: "page" | "full" | "section";
	as?: "div" | "section" | "article" | "main";
	asChild?: boolean;
	dataBlok?: boolean;
}

const BlokWrap = ({
	children,
	editable,
	layout,
	as: Component = "section",
	asChild,
	dataBlok = true,
	...rest
}: PropsWithChildren<BlokWrapProps>) => {
	const ComponentToUse = asChild ? Slot : Component;
	const props = {
		...rest,
		"data-blok": dataBlok ? true : undefined,
		"data-blok-name":
			process.env.NODE_ENV === "development" ? editable.component : undefined,
	};

	const key =
		"background" in editable
			? "background"
			: "backgroundColor" in editable
				? "backgroundColor"
				: undefined;

	const shouldApplyColor =
		key &&
		typeof (editable[key as keyof typeof editable] as { value: string })
			.value === "string";

	return (
		<ComponentToUse
			{...storyblokEditable(editable as SbBlokData)}
			{...props}
			style={
				{
					"--background-color": shouldApplyColor
						? (editable[key as keyof typeof editable] as { value: string })
								.value
						: "",
				} as React.CSSProperties
			}
			data-color={shouldApplyColor ? true : undefined}
		>
			{children}
		</ComponentToUse>
	);
};

export default BlokWrap;
